module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player-box"
  }, [_c('audio', {
    ref: "player",
    attrs: {
      "preload": _vm.options.preload,
      "controls": _vm.options.controls
    },
    on: {
      "ready": _vm.hanleReady,
      "timeupdate": _vm.handleTimeUpdated,
      "ended": _vm.onEnded,
      "error": _vm.onError,
      "canplaythrough": _vm.hanleCanPlay
    }
  }, [_vm._v("\n    >\n    "), [_c('source', {
    attrs: {
      "src": _vm.audio.url,
      "type": "audio/mp3"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.audio.url,
      "type": "audio/ogg"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "custom-controls"
  }, [_c('div', {
    staticClass: "play-bar"
  }, [_c('Button', {
    attrs: {
      "icon": _vm.isPlaying ? 'ios-pause' : 'ios-play',
      "type": "default",
      "shape": "circle",
      "size": "small",
      "disabled": !_vm.canPlay
    },
    on: {
      "click": _vm.play
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('Slider', {
    ref: "progress",
    attrs: {
      "max": _vm.audio.durationMax,
      "tip-format": _vm.progressTipFormat,
      "show-tip": "never"
    },
    on: {
      "on-change": _vm.progressChange
    },
    model: {
      value: (_vm.audio.currentTime),
      callback: function($$v) {
        _vm.$set(_vm.audio, "currentTime", $$v)
      },
      expression: "audio.currentTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-bar"
  }, [_vm._v(_vm._s(_vm.audio.displayTime) + "/" + _vm._s(_vm.audio.durationTime))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5846dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/AudioPlayer.vue
// module id = 725
// module chunks = 1